/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Grant} from '../models/Grant';
import type {GrantList} from '../models/GrantList';

export interface GetProductGrantsByIds$Request {
    requestBody: Array<string>;
}

export interface GetProductGrantsByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductGrantsByIdsRequest = createAction<PayloadData<void, GetProductGrantsByIds$Request>>('PRODUCT_ENTITLEMENTS_GRANT__GET_PRODUCT_GRANTS_BY_IDS__REQUEST');
export const getProductGrantsByIdsSuccess = createAction<PayloadData<{ [key: string]: Grant; }, GetProductGrantsByIds$Request>>('PRODUCT_ENTITLEMENTS_GRANT__GET_PRODUCT_GRANTS_BY_IDS__SUCCESS');
export const getProductGrantsByIdsFailure = createAction<PayloadData<Error, GetProductGrantsByIds$Request, true>>('PRODUCT_ENTITLEMENTS_GRANT__GET_PRODUCT_GRANTS_BY_IDS__FAILURE');

export const getProductGrantsByIdsActions = [
    getProductGrantsByIdsRequest,
    getProductGrantsByIdsSuccess,
    getProductGrantsByIdsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductGrantsByIds = (meta: GetProductGrantsByIds$Request, config?: GetProductGrantsByIds$Config) => {
    return {
        CALL_API: {
            types: getProductGrantsByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/entitlements/grants`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductGrantsWithoutRelations$Request {
    pageSize: number;
    pageNumber: number;
}

export interface GetProductGrantsWithoutRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductGrantsWithoutRelationsRequest = createAction<PayloadData<void, GetProductGrantsWithoutRelations$Request>>('PRODUCT_ENTITLEMENTS_GRANT__GET_PRODUCT_GRANTS_WITHOUT_RELATIONS__REQUEST');
export const getProductGrantsWithoutRelationsSuccess = createAction<PayloadData<GrantList, GetProductGrantsWithoutRelations$Request>>('PRODUCT_ENTITLEMENTS_GRANT__GET_PRODUCT_GRANTS_WITHOUT_RELATIONS__SUCCESS');
export const getProductGrantsWithoutRelationsFailure = createAction<PayloadData<Error, GetProductGrantsWithoutRelations$Request, true>>('PRODUCT_ENTITLEMENTS_GRANT__GET_PRODUCT_GRANTS_WITHOUT_RELATIONS__FAILURE');

export const getProductGrantsWithoutRelationsActions = [
    getProductGrantsWithoutRelationsRequest,
    getProductGrantsWithoutRelationsSuccess,
    getProductGrantsWithoutRelationsFailure
] as const;

/**
 * @param {number} meta.pageSize
 * @param {number} meta.pageNumber
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductGrantsWithoutRelations = (meta: GetProductGrantsWithoutRelations$Request, config?: GetProductGrantsWithoutRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageSize: meta.pageSize,
        pageNumber: meta.pageNumber,
    };
    return {
        CALL_API: {
            types: getProductGrantsWithoutRelationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/entitlements/grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

